import { useCreateMachine } from 'fsm';
import { useCurrentUser } from 'policy-lib';
import { SmartFillModalContext } from './context';
import { machine } from './machine';
import { usePanelAlerts } from '../../../Panel/usePanelAlerts';
import { FILL_EMPTY_ONLY_OPTION_VAL } from '../../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const SmartFillModalContextProvider = ({
  children,
  onClose,
  onEnrich,
  propertyName,
  objectTypeId,
  selectionCrmSearchQuery,
  selectionObjects,
  selectionMethod
}) => {
  var _selectionObjects$map, _selectionObjects$fil, _selectionObjects$len;
  const currentUser = useCurrentUser();
  const {
    onError,
    onSuccessProperties
  } = usePanelAlerts({
    objectTypeId: objectTypeId
  });
  const selectionIds = (_selectionObjects$map = selectionObjects === null || selectionObjects === void 0 ? void 0 : selectionObjects.map(obj => obj.objectId)) !== null && _selectionObjects$map !== void 0 ? _selectionObjects$map : [];
  const selectionIdsWithEmptyProperty = (_selectionObjects$fil = selectionObjects === null || selectionObjects === void 0 ? void 0 : selectionObjects.filter(obj => {
    const property = obj.properties[propertyName];
    return !property || !property.value;
  }).map(obj => obj.objectId)) !== null && _selectionObjects$fil !== void 0 ? _selectionObjects$fil : [];
  const totalWithEmptyProperties = selectionMethod === 'BY_IDS' ? selectionIdsWithEmptyProperty.length : 0;
  const initialContext = {
    enrichmentType: 'company',
    errorId: null,
    fillOption: FILL_EMPTY_ONLY_OPTION_VAL,
    objectTypeId: objectTypeId,
    onClose,
    onEnrich,
    onError,
    onSuccess: onSuccessProperties,
    propertyName,
    selectedProperties: [propertyName],
    selectionCrmSearchQuery,
    selectionIds,
    selectionIdsWithEmptyProperty,
    selectionMethod,
    selectionObjects,
    total: (_selectionObjects$len = selectionObjects === null || selectionObjects === void 0 ? void 0 : selectionObjects.length) !== null && _selectionObjects$len !== void 0 ? _selectionObjects$len : 0,
    totalWithEmptyProperties
  };
  const smartFillModalMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded
  });
  return /*#__PURE__*/_jsx(SmartFillModalContext.Provider, {
    value: smartFillModalMachine,
    children: children
  });
};